module.exports = __webpack_public_path__ + "img/air-max-dia-womens-shoe.efa90bd1.png";